
const AVATAR_IMAGE = '/assets/avartar.png'
const PROFILE_AVATAR_IMAGE = '/assets/profile-avatar.png'
export default (isProfile) => {
  const image = localStorage.getItem('line_profile_image');
  if (image) {
    return image
  }
  if (isProfile) {
    return PROFILE_AVATAR_IMAGE
  }
  return AVATAR_IMAGE
}